import React from "react";
import { PrimaryButton, SecondaryButton } from "src/ui/shared/CustomButton";

import { LoadingButtonProps } from "@mui/lab";
import { TooltipProps } from "@mui/material";

export interface DropdownTriggerProps extends LoadingButtonProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    tooltipProps?: Omit<TooltipProps, "arrow" | "children">;
    buttonType?: "primary" | "secondary";
}

export function DropdownTrigger({
    children,
    onClick,
    className = "",
    buttonType = "secondary",
    ...props
}: DropdownTriggerProps): React.JSX.Element {
    const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onClick(e);
    };

    const ButtonComponent = buttonType === "primary" ? PrimaryButton : SecondaryButton;

    return (
        <ButtonComponent aria-haspopup="true" onClick={(e) => handleToggle(e)} className={`${className}`} {...props}>
            {children}
        </ButtonComponent>
    );
}
